import store_config from '@/store/mods/parametres/config.js'
import store_consultation from '@/store/mods/consultations/consultations'
import DateFilter from '@/components/date-filter';
import ViewTraitement from '@/views/consultations/admissions/view-traitement'
import $ from 'jquery'

export default {
    name: 'admissions',
    components: {
        DateFilter, ViewTraitement
    },
    props: [],
    data() {
        return {
            liste_admissions: [],
            selected_admission: '',
            current_date_filter: {},
            curr_month: "", 
            filter_date: '',
            date_filters: [
                { slug: 'date', libelle: 'Date' },
                { slug: 'entre_deux_date', libelle: 'Entre deux dates' }
            ],
            filter_by_date: { slug: '', libelle: '' },
            is_month: false,
            is_loading: true,
            is_empty: false,
            is_error: false,

            liste_patients_admissions: [],
            curr_page: 1,
            per_page: -1,
            total_pages: 0,
            filter: '',
            last_page: 0,
            goto_page: 1,
            search_term: '',
            from_index: 1,

            // 'sexe', 
            //     { key: 'age', label: 'Âge' },  'patient_telephone',
            fields: [
                { key: 'index', label: 'N°' },
                { key: 'patient_code', label: 'Numéro de dossier' }, 
                { key: 'patient_nom', label: 'Patient' }, 
                'assurance', 'admission', { key: 'traitement', label: 'Traitement en cours' }
            ],
            consultation_id: 0,
            toggler: 0
        }
    },

    watch: {
        filter_date() {
            if (this.filter_date != '') {
                this.filter_by_date = this.filter_date;
                if (this.filter_by_date.slug) {
                    $('.date-filter').modal('show')
                }
            }
        },

        curr_month() {
            const data = {
                month: this.curr_month.id,
                one_date: "",
                from_date: "",
                to_date: ""
            }
            this.current_date_filter = data
            this.is_month = true
            this.getPatientsAdmssions()
        },

        selected_admission() {
            if (this.selected_admission.libelle == 'Tout') {
                this.current_date_filter.type_admission = ''
            } else {
                this.current_date_filter.type_admission = this.selected_admission.libelle
            }
            
            this.getPatientsAdmssions()
        }
    },

    computed: {

    },

    mounted() {
        this.getListeAdmission()

        const data = {
            month: "",
            one_date: this.getDates().today_date,
            from_date: "",
            to_date: ""
        }
        this.current_date_filter = data
        this.getPatientsAdmssions()
    },

    methods: {
        getListeAdmission() {
            const all_type = {
                admission_id: 0,
                libelle: 'Tout'
            }
            

            const data_type = 'admission'
            store_config.getListeAdmissions(data_type).then((response) => {
                this.liste_admissions = response
                this.liste_admissions.push(all_type)
            })
        },

        getPatientsAdmssions() {
            this.is_loading = true
            
            this.current_date_filter.page = this.goto_page
            store_consultation.getPatientsAdmissionEnCours(this.current_date_filter).then((response) => {
                this.liste_patients_admissions = response.data
                this.last_page = response.last_page
                this.total_pages = response.last_page
                this.from_index = response.from

                if (this.liste_patients_admissions.length == 0) {
                    this.is_empty = true
                } else {
                    this.is_empty = false
                }
                this.is_loading = false
            }).catch(() => {
                this.is_loading = false
                this.is_error = true
            })
        },

        filterByDate(date) {
            this.operations_tobe_canceled = []
            const data = {
                month: "",
                one_date: date.single_date,
                from_date: date.from_date,
                to_date: date.to_date,
                from_hour: date.from_hour,
                to_hour: date.to_hour,
                page: 1
            }
            this.current_date_filter = data
            this.filter_date = ""
            this.is_month = false

            this.getPatientsAdmssions()
        },

        previousPage() {
            if (this.curr_page > 1) {
                this.curr_page--;
                this.goto_page = this.curr_page
                this.getPatientsAdmssions()
            }
        },

        nextPage() {
            if (this.curr_page < this.total_pages) {
                this.curr_page++;
                this.goto_page = this.curr_page
                this.getPatientsAdmssions()
            }
        },

        gotoPage(page) {
            if (page !== this.curr_page) {
                this.curr_page = page;
                this.goto_page = this.curr_page
                this.getPatientsAdmssions()
            }
        },

        viewTraitement(consultation_id) {
            this.toggler = (this.toggler == 0)?1:0
            this.consultation_id = consultation_id

            $('.view-treatment').modal('show')
        },

        goToConsultation(patient_id, tarif_consultation_id) {
            const data = {
                patient_id: patient_id,
                tarif_consultation_id: tarif_consultation_id,
                view_treatment: 1
            }
            this.$store.commit("SET_SELECTED_CONSULTATION_ENCOURS", data);
            this.$router.push({ path: 'patients/'+patient_id+'/consulter' })
        },
    }
}